export enum RaptorParameterKeys {
    UserId = 'userId',
    ProductId = 'productId',
}

export const raptorBasketFeedType = 'GetRelatedItemsForBasket';
